import React, { useEffect, useState } from 'react'
import styled from 'styled-components/macro'
import PropTypes from 'prop-types'
import MuiAppBar from '@material-ui/core/AppBar'

// import { DetectDeviceContext } from 'wsc/components/context/DetectDeviceProvider'
// import { PreviewSiteBannerStateContext } from 'wsc/components/context/PreviewSiteBannerProvider'
import { updateOneTrustBanner } from 'wsc/utils/oneTrustLib'
import { COLORS } from '../../utils/styles'
// import { PostNavContext } from 'wsc/components/context/PostNavProvider'
// import { PostNavBar } from 'wsc/components/post/PostNav'
// import { getConfig } from 'wsc/globalConfig'

// const styleConfig = getConfig('StyleConfig')

let checkedRampIsMobile = false

// MuiAppBar contains <header> tag
const ScAppBar = styled(({ isHideOnScreen, top, rampIsMobile, ...restProps }) => (
  <MuiAppBar {...restProps} />
))`
  && {
    background: ${COLORS.WHITE};
    color: ${COLORS.BLACK};

    // fading animation
    -webkit-transition: -webkit-transform 0.3s;
    -webkit-transform: translateY(0);
    transition: transform 0.3s;
    transform: translateY(0);
    ${props => props.top && `top: ${props.top}`};
    // rampIsMobile === true    =>  flex-leaderboard-docked always have height = 70px
    // rampIsMobile === false   =>  have height = 100px when viewport width >= 655px
    .flex-leaderboard-docked & {
      top: 70px;
      ${({ rampIsMobile }) =>
        rampIsMobile === false &&
        `
        @media (min-width: 655px) {
          top: 100px;
        }
      `}
    }
  }
`

/*----------------------------------------------------------------------------------
 *  RENDER PHASE
 *---------------------------------------------------------------------------------*/

const AppBar = props => {
  const [rampIsMobile, setRampIsMobile] = useState(undefined)
  // const { isMobile } = useContext(DetectDeviceContext)
  // const { isShowPreviewSiteBar } = useContext(PreviewSiteBannerStateContext)
  // const { isShowPostNavBar, setPostNavBarOffset } = useContext(PostNavContext)

  // save `window.ramp.isMobile` to the state `rampIsMobile` of this component
  useEffect(() => {
    if (checkedRampIsMobile) return
    checkedRampIsMobile = true

    window.ramp = window.ramp || {}
    // window.ramp.que = window.ramp.que || []
    // window.ramp.que.push(() => {
    //   setRampIsMobile(window.ramp.isMobile)
    // })
    window.ramp.onReady = () => {
      setRampIsMobile(window.ramp.isMobile)
    }
  }, [])

  useEffect(() => {
    updateOneTrustBanner()
  }, [])

  // useEffect(() => {
  //   let navBarOffset = isMobile
  //     ? styleConfig.NAVIGATION_BAR_HEIGHT_MOBILE
  //     : styleConfig.NAVIGATION_BAR_HEIGHT
  //   setPostNavBarOffset(navBarOffset)
  // }, [isMobile, setPostNavBarOffset])

  return (
    <ScAppBar
      className={props.className}
      position="sticky" // Material-UI's `AppBar` component requires `position` props
      top={0}
      rampIsMobile={rampIsMobile}
    >
      {/* {isShowPostNavBar && <PostNavBar inAppBar={true}></PostNavBar>} */}
      {/* set `props.children` to be the last-child for guarantee that
          they will not be covered by the sibling element with the same z-index */}
      {props.children}
    </ScAppBar>
  )
}

AppBar.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
}

AppBar.defaultProps = {
  className: '',
  children: null,
}

export default AppBar
